export const isProfitMarginTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  transactionType.charAt(9) === "1";

export const isAnyProfitMarginTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  (transactionType.charAt(9) === "1" || transactionType.charAt(10) === "1");

export const isProfitMarginSelfBillingTransactionType = (transactionType) =>
    typeof transactionType === "string" &&
    transactionType.length === 20 &&
    transactionType.charAt(10) === "1";
